<template>
  <v-tooltip v-if="onValidarBoton" bottom>
    <template v-slot:activator="{ on }" >
      <div @click="emitEvento()" v-on="on" class="d-flex justify-start align-center hvr">
        <v-btn color="primary" class="mx-1" outlined width="27px" height="27px" icon  >
          <v-icon size="13px" class="btncolor--text mx-1" >
            {{iconb[0].iconname }}
          </v-icon> 
        </v-btn>
        <p class="ma-0">
          <slot name="slotTextoMensaje"></slot> 
        </p>
      </div>
    </template>
    <span>{{HoverMensaje}}</span>
  </v-tooltip>
</template>

<script>

export default {
  name:"BtnGrid",
  props: {
    item: {
      type:Object,
      default: () => {}
    },
    HoverMensaje:{
      type: String,
      default: 'Sin Mensaje'
    },
    oPermisos: {
      type: Object,
      default: () => {}
    },
    oProps: {
      type: Object,
    },
    typebtn:null
  },
  data() {
    return {
        listbtn:[
          {name:'BtnAddUser', iconname:'fa-user-plus', eventName:'btnAddUser'},
          {name:'BtnColor', iconname:'fa-palette', eventName:'btnColor'},
          {name:'BtnDetalleCliente', iconname:'fa-eye',eventName:'btnDetails'},
          {name:'BtnEdit', iconname:'fa-pencil-alt',eventName:'btnEdit'},
          {name:'BtnMapa', iconname:'fas fa-map-marker-alt',eventName:'btnMapa'},
          {name:'BtnFirmas', iconname:'fas fa-signature',eventName:'btnFirmas'},
          {name:'BtnImagenes', iconname:'fas fa-images',eventName:'btnImagenes'},
          {name:'BtnAnexos', iconname:'mdi-paperclip',eventName:'btnAnexos'},
          {name:'BtnBuildCorreos', iconname:'fa-pencil-alt',eventName:'btnBuildCorreos'},
          {name:'BtneGestionar', iconname:'fas fa-share-square',eventName:'btneGestionar'},
          {name:'BtnAgregarObs', iconname:'mdi-comment-plus-outline',eventName:'btnAgregarObs'},
          {name:'BtnNuevaContrasena', iconname:'mdi-lock-reset',eventName:'btnNuevaContrasena'},
          {name:'BtnCerrarSesionApp', iconname:'mdi-exit-to-app',eventName:'btnCerrarSesionApp'},
          {name:'BtnEditGesDoc', iconname:'mdi-file-document-edit',eventName:'btnEditGesDoc'},
          {name:'BtnAnalizar', iconname:'mdi-redo-variant',eventName:'btnAnalizar'},
          {name:'BtnConvertir', iconname:'mdi-redo-variant',eventName:'btnConvertir'},
          {name:'BtnEvaluar', iconname:'mdi-redo-variant',eventName:'btnEvaluar'},
          {name:'BtnRecomendacion', iconname:'mdi-redo-variant',eventName:'btnRecomendacion'},
          {name:'BtnNewEditPerfilAccesoRiesgos', iconname:'fa-pencil-alt',eventName:'btnNewEditPerfilAccesoRiesgos'},
          {name:'BtnEliminar', iconname:'mdi-delete',eventName:'btnEliminar'},
          {name:'BtnFormulario', iconname:'mdi-form-dropdown',eventName:'btnFormulario'},
          {name:'BtnDinamico', iconname:'fas fa-share-square',eventName:'btnDinamico'},
          {name:'BtnEditarSAC', iconname: 'mdi-pencil', eventName:'btnEditarSAC'},
          {name:'BtnGenerico', iconname: 'mdi-cog-refresh',eventName: 'btnGenerico'},
        ],
        iconb:[{ name:'BtnDetalleCliente', iconname: 'fa-home'}]
    }//fin return
  }, // Fin data
  mounted() {
    this.cambiarIcono(this.typebtn)
  },
  methods: {
      cambiarIcono(val){
        this.iconb = this.listbtn.filter(item => item.name == val)
        if (val === 'BtnGenerico') {
          if (this.oProps.hasOwnProperty('iconname')) {
            this.iconb[0].iconname = this.oProps.iconname
          }
          if (this.oProps.hasOwnProperty('colorTexto')) {
            this.iconb[0].colorTexto = this.oProps.colorTexto
          }
        }
    },
    emitEvento(){
        this.$emit('btnActionEvento',{btnName: this.iconb[0].eventName, item: this.item ,oProps: this.oProps})
    },
  },
  computed: {
    onValidarBoton(){
      let oPermitir = true
      if(this.typebtn=='BtnBuildCorreos' || this.typebtn=='BtnEdit'){
        if(this.oPermisos.priv_update=='0') oPermitir = false
      }
      return oPermitir
    }
  }
}

</script>

<style lang="scss" scoped>
.hvr{
  cursor: pointer;
}
</style>